export enum WarehouseControls {
  warehouse = 'warehouse',
  city = 'city',
}
